//#region ClickEventHandler Class

/**
 * Handles binding and unbinding of click event listeners to a specified HTML container element.
 * Provides a clean interface for managing click events, ensuring proper setup and teardown.
 */
export class ClickEventHandler {
	/**
	 * The HTML element to which the click event listener will be attached.
	 */
	private container: HTMLElement | null;

	/**
	 * The click event listener function.
	 */
	private listener: (e: MouseEvent) => void;

	/**
	 * Creates an instance of ClickEventHandler.
	 * @param container - The HTML element to attach the click event listener to. Can be null.
	 * @param listener - The function to be called when a click event occurs.
	 */
	constructor(container: HTMLElement | null, listener: (e: MouseEvent) => void) {
		this.container = container;
		this.listener = listener;
	}

	/**
	 * Binds the click event listener to the container element.
	 * Does nothing if the container is null.
	 */
	public bind(): void {
		if (!this.container) return;
		this.container.addEventListener("click", this.listener);
	}

	/**
	 * Unbinds the click event listener from the container element.
	 * Does nothing if the container is null.
	 */
	public unbind(): void {
		if (!this.container) return;
		this.container.removeEventListener("click", this.listener);
	}
}

//#endregion
